import {
  MOBILE_BOTTOM_NAV_API_SUCCESS,
  MOBILE_BOTTOM_NAV_API_ERROR
} from '../../constants/constant';

const initialMobileBottomNavState = {
  fallback: true,
  list: []
};

function mobileBottomNavReducer(state = initialMobileBottomNavState, action) {
  switch (action.type) {
    case MOBILE_BOTTOM_NAV_API_SUCCESS:
      return { ...state, ...action.data };
    case MOBILE_BOTTOM_NAV_API_ERROR:
      return { ...state, ...action.data };
    default:
      return state;
  }
}

export default mobileBottomNavReducer;
